import { render, staticRenderFns } from "./GlobalSportsHeaderCard.vue?vue&type=template&id=20c65fb0&scoped=true"
import script from "./GlobalSportsHeaderCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalSportsHeaderCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalSportsHeaderCard.vue?vue&type=style&index=0&id=20c65fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c65fb0",
  null
  
)

export default component.exports